export default "__VITE_ASSET__DWa4xT6D__"